import { MonthYear } from "@common/types";
import { ICommandBase } from "@Quest/cqrs";

export class CreateCorporateScenarioCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.CreateCorporateScenarioCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Description: string;
	PlanningStartDate: MonthYear;
	PlanningEndDate: MonthYear;
	Denomination: string;
	ApplyBenefitsConfidenceFactor: boolean;
	BenefitsConfidenceDate: MonthYear | null;
	PortfolioIds: string[];

	constructor(workspaceId: number, strategyId: string, scenarioId: string, name: string, description: string, planningStartDate: MonthYear, planningEndDate: MonthYear,
		denomination: string, applyBenefitsConfidenceFactor: boolean, benefitsConfidenceDate: MonthYear | null, portfolioIds: string[])
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = scenarioId;
		this.Name = name;
		this.Description = description;
		this.PlanningStartDate = planningStartDate;
		this.PlanningEndDate = planningEndDate;
		this.Denomination = denomination;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
		this.BenefitsConfidenceDate = benefitsConfidenceDate;
		this.PortfolioIds = portfolioIds;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.CreateCorporateScenarioCommandV1, TCh.Domain.Quest'
	}
}

export class UpdateCorporateScenarioCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.UpdateCorporateScenarioCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Description: string;
	PlanningStartDate: MonthYear;
	PlanningEndDate: MonthYear;
	Denomination: string;
	ApplyBenefitsConfidenceFactor: boolean;
	BenefitsConfidenceDate: MonthYear | null;
	PortfolioIds: string[];

	constructor(workspaceId: number, strategyId: string, scenarioId: string, name: string, description: string, planningStartDate: MonthYear, planningEndDate: MonthYear,
		denomination: string, applyBenefitsConfidenceFactor: boolean, benefitsConfidenceDate: MonthYear | null, portfolioIds: string[])
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = scenarioId;
		this.Name = name;
		this.Description = description;
		this.PlanningStartDate = planningStartDate;
		this.PlanningEndDate = planningEndDate;
		this.Denomination = denomination;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
		this.BenefitsConfidenceDate = benefitsConfidenceDate;
		this.PortfolioIds = portfolioIds;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.UpdateCorporateScenarioCommandV1, TCh.Domain.Quest'
	}
}

export class CloneCorporateScenarioCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.CloneCorporateScenarioCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	SourceId: string;
	Id: string;
	CloneName: string;

	constructor(workspaceId: number, strategyId: string, sourceId: string, cloneId: string, cloneName: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.SourceId = sourceId;
		this.Id = cloneId;
		this.CloneName = cloneName;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.CloneCorporateScenarioCommandV1, TCh.Domain.Quest'
	}
}



export class UpdateActivePortfolioScenarioCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.UpdateActivePortfolioScenarioCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	PortfolioId: string;
	PortfolioScenarioId: string;

	constructor(workspaceId: number, strategyId: string, scenarioId: string, portfolioId: string, portfolioScenarioId: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = scenarioId;
		this.PortfolioId = portfolioId;
		this.PortfolioScenarioId = portfolioScenarioId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.UpdateActivePortfolioScenarioCommandV1, TCh.Domain.Quest'
	}
}


export class SetPortfolioResourceAllocationCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioResourceAllocationCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	PortfolioId: string;
	ResourceId: string;
	Allocation: number;

	constructor(workspaceId: number, strategyId: string, scenarioId: string, portfolioId: string, resourceId: string, allocation: number)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = scenarioId;
		this.PortfolioId = portfolioId;
		this.ResourceId = resourceId;
		this.Allocation = allocation;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioResourceAllocationCommandV1, TCh.Domain.Quest'
	}
}

export class SetPortfolioTotalCostLimitCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioTotalCostLimitCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	PortfolioId: string;
	Limit: number | null;

	constructor(workspaceId: number, strategyId: string, scenarioId: string, portfolioId: string, limit: number | null)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = scenarioId;
		this.PortfolioId = portfolioId;
		this.Limit = limit;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioTotalCostLimitCommandV1, TCh.Domain.Quest'
	}
}

export class SetPortfolioOpexLimitCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioOpexLimitCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	PortfolioId: string;
	Limit: number | null;

	constructor(workspaceId: number, strategyId: string, scenarioId: string, portfolioId: string, limit: number | null)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = scenarioId;
		this.PortfolioId = portfolioId;
		this.Limit = limit;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioOpexLimitCommandV1, TCh.Domain.Quest'
	}
}

export class SetPortfolioOthexLimitCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioOthexLimitCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	PortfolioId: string;
	Limit: number | null;

	constructor(workspaceId: number, strategyId: string, scenarioId: string, portfolioId: string, limit: number | null)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = scenarioId;
		this.PortfolioId = portfolioId;
		this.Limit = limit;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioOthexLimitCommandV1, TCh.Domain.Quest'
	}
}


export class SetPortfolioExpensesLimitCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioExpensesLimitCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	PortfolioId: string;
	Limit: number | null;

	constructor(workspaceId: number, strategyId: string, scenarioId: string, portfolioId: string, limit: number | null)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = scenarioId;
		this.PortfolioId = portfolioId;
		this.Limit = limit;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioExpensesLimitCommandV1, TCh.Domain.Quest'
	}
}

export class SetPortfolioOpexExpensesLimitCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioOpexExpensesLimitCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	PortfolioId: string;
	Limit: number | null;

	constructor(workspaceId: number, strategyId: string, scenarioId: string, portfolioId: string, limit: number | null)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = scenarioId;
		this.PortfolioId = portfolioId;
		this.Limit = limit;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioOpexExpensesLimitCommandV1, TCh.Domain.Quest'
	}
}


export class SetPortfolioCapexLimitCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioCapexLimitCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	PortfolioId: string;
	Limit: number | null;

	constructor(workspaceId: number, strategyId: string, scenarioId: string, portfolioId: string, limit: number | null)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = scenarioId;
		this.PortfolioId = portfolioId;
		this.Limit = limit;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioCapexLimitCommandV1, TCh.Domain.Quest'
	}
}



export class DeleteCorporateScenarioCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.DeleteCorporateScenarioCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;

	constructor(workspaceId: number, strategyId: string, scenarioId: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = scenarioId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.DeleteCorporateScenarioCommandV1, TCh.Domain.Quest'
	}
}

export class OptimizeCorporateScenarioScheduleCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.OptimizeCorporateScenarioScheduleCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	MinStartDate: MonthYear;
	MaxStartDate: MonthYear;

	constructor(workspaceId: number, strategyId: string, scenarioId: string, minStartDate: MonthYear, maxStartDate: MonthYear)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = scenarioId;
		this.MinStartDate = minStartDate;
		this.MaxStartDate = maxStartDate;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.CorporateScenarios.Commands.OptimizeCorporateScenarioScheduleCommandV1, TCh.Domain.Quest';
	}
}